/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateTranslationDto } from '../model/createTranslationDto';
import { EntityId } from '../model/entityId';
import { Locale } from '../model/locale';
import { TranslatableEntity } from '../model/translatableEntity';
import { Translation } from '../model/translation';
import { UpdateTranslationDto } from '../model/updateTranslationDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TranslationApiService {

    protected basePath = 'https://app-tst.pikyrent.com:33443';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create a translation
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createTranslation(body: CreateTranslationDto, observe?: 'body', reportProgress?: boolean): Observable<Translation>;
    public createTranslation(body: CreateTranslationDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Translation>>;
    public createTranslation(body: CreateTranslationDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Translation>>;
    public createTranslation(body: CreateTranslationDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling createTranslation.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Translation>('post',`${this.basePath}/translations/`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a translation by id
     * Deletes a translation and returns the removed translation object.
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTranslation(id: number, observe?: 'body', reportProgress?: boolean): Observable<Translation>;
    public deleteTranslation(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Translation>>;
    public deleteTranslation(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Translation>>;
    public deleteTranslation(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTranslation.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Translation>('delete',`${this.basePath}/translations/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Find translations (filtered)
     * 
     * @param entityType 
     * @param entityId 
     * @param locale 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public findTranslations(entityType?: TranslatableEntity, entityId?: EntityId, locale?: Locale, observe?: 'body', reportProgress?: boolean): Observable<Array<Translation>>;
    public findTranslations(entityType?: TranslatableEntity, entityId?: EntityId, locale?: Locale, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Translation>>>;
    public findTranslations(entityType?: TranslatableEntity, entityId?: EntityId, locale?: Locale, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Translation>>>;
    public findTranslations(entityType?: TranslatableEntity, entityId?: EntityId, locale?: Locale, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (entityType !== undefined && entityType !== null) {
            queryParameters = queryParameters.set('entityType', <any>entityType);
        }
        if (entityId !== undefined && entityId !== null) {
            queryParameters = queryParameters.set('entityId', <any>entityId);
        }
        if (locale !== undefined && locale !== null) {
            queryParameters = queryParameters.set('locale', <any>locale);
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Translation>>('get',`${this.basePath}/translations/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a translation by id
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getTranslationById(id: number, observe?: 'body', reportProgress?: boolean): Observable<Translation>;
    public getTranslationById(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Translation>>;
    public getTranslationById(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Translation>>;
    public getTranslationById(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getTranslationById.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Translation>('get',`${this.basePath}/translations/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a translation value
     * Updates only the &#x60;value&#x60; field of a specific translation.
     * @param body 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTranslation(body: UpdateTranslationDto, id: number, observe?: 'body', reportProgress?: boolean): Observable<Translation>;
    public updateTranslation(body: UpdateTranslationDto, id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Translation>>;
    public updateTranslation(body: UpdateTranslationDto, id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Translation>>;
    public updateTranslation(body: UpdateTranslationDto, id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling updateTranslation.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTranslation.');
        }

        let headers = this.defaultHeaders;

        // authentication (accessToken) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Auth"]) {
            headers = headers.set('Auth', this.configuration.apiKeys["Auth"]);
        }

        // authentication (apiKey) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["ApiKey"]) {
            headers = headers.set('ApiKey', this.configuration.apiKeys["ApiKey"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<Translation>('patch',`${this.basePath}/translations/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
